import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../editor/toolbar/Button";
import {
  JobRatingLabel,
  NonUnionMarinersByRating,
} from "../../common/JobOrder";

const NonUnionMariners = (props: {
  nonUnionMariners: NonUnionMarinersByRating[];
  onClose?: (bol: boolean) => void;
}) => {
  const closeDialog = () => {
    if (!!props.onClose) {
      props.onClose(false);
    }
  };

  return (
    <div>
      <div className="flex align-items-center justify-content-btwn mb-1">
        <h1>Non-Union Mariners</h1>
        {!!props?.onClose && (
          <div>
            <Button onClick={closeDialog}>
              <CloseIcon />
            </Button>
          </div>
        )}
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Vessel</TableCell>
            <TableCell>Rating</TableCell>
            <TableCell>Count</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.nonUnionMariners.map((row) => {
            return (
              <TableRow key={`${row.vesselId}-${row.rating}`}>
                <TableCell>{row.vessel}</TableCell>
                <TableCell>{JobRatingLabel[row.rating]}</TableCell>
                <TableCell>{row.nonUnionMariners}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default NonUnionMariners;
